var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isIE)?_c('div',{staticClass:"keyboard-wrapper slideInUp fast",attrs:{"id":"simple-keyboard"}},[_c('div',{staticClass:"inner-wrapper",attrs:{"id":"simple-keyboard"}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"simple-keyboard"})],2)]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c76458","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/keyboard/CustomKeyboard.vue
// module id = 443
// module chunks = 187